import { Injectable } from '@angular/core';
import { GlobalEventBusService, hd, TicketContextService as XSightTicketContextService } from '@nx-fe/services';
import { GlobalEvents } from 'sspapp/core/global-event-constants';
import { Activity, IDeviceModel, INewAssociatedDeviceModel, Ticket } from 'sspapp/modules/ticket/ticket.model';

@Injectable({ providedIn: 'root' })
export class TicketContextService {
  private _ticket: Ticket;
  private _activities: Activity[] = [];
  private _associatedDevices: IDeviceModel[] = [];
  private _devicesToAssociate: INewAssociatedDeviceModel[] = [];

  constructor(
    private xSightTicketContextService: XSightTicketContextService,
    private globalEventBusService: GlobalEventBusService
  ) {
    this.globalEventBusService.register(GlobalEvents.selectedDevice, () => {
      this.resetTicketContext();
    });
  }

  public get ticket(): Ticket {
    return this._ticket;
  }

  public set ticket(ticket: Ticket) {
    if (this._ticket !== ticket) {
      this._ticket = ticket;
      //Some of activities components are using the context and logic from XSight TicketContext, so setup ticket for that
      this.xSightTicketContextService.ticket = ticket as unknown as hd.ITicketModel;
    }
  }

  public set associatedDevices(associatedDevices: IDeviceModel[]) {
    this._associatedDevices = associatedDevices;
  }

  public get associatedDevices(): IDeviceModel[] {
    return this._associatedDevices;
  }

  public get devicesToAssociate(): INewAssociatedDeviceModel[] {
    return this._devicesToAssociate;
  }

  public set devicesToAssociate(devicesToAssociate: INewAssociatedDeviceModel[]) {
    this._devicesToAssociate = devicesToAssociate;
  }

  public get activities(): Activity[] {
    return this._activities;
  }

  public set activities(activities: Activity[]) {
    this._activities = activities;
  }

  public resetTicketContext = () => {
    this.ticket = undefined;
    this.activities = [];
    this.associatedDevices = [];
  };

  public get isLicenceExpired(): boolean {
    return this.xSightTicketContextService.isLicenceExpired;
  }
}
